import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { Dropdown, Icon } from 'semantic-ui-react'

import PostSchema from '../../../schemas/PostSchema'
import SharedPostSchema from '../../../schemas/SharedPostSchema'
import UserSchema from '../../../schemas/UserSchema'

import './PostOptions.css'

class PostOptions extends PureComponent {
  onBlockPost = () => this.props.onBlockPost(this.props.post)

  onDeletePost = () => this.props.onDeletePost(this.props.post)

  onEditPost = () => this.props.onEditPost(this.props.post)

  onHidePost = () => this.props.onHidePost(this.props.post)

  onUnsharePost = () => this.props.onUnsharePost(this.props.post)

  render() {
    const {
      isAdmin,
      post: { post: content, sharer },
      viewer,
    } = this.props
    const post = content || this.props.post
    const { user } = post
    const options = []

    if (isAdmin || viewer.id === user.id) {
      // Is my post
      /**
       * @todo Agregar acción de editar
       */
      /*
      options.push({
        icon: 'pencil',
        onClick: this.onEditPost,
        text: 'Editar',
      })
      */
      options.push({
        icon: 'trash alternate outline',
        onClick: this.onDeletePost,
        text: 'Eliminar',
      })
    } else if (sharer && viewer.id === sharer.id) {
      // Is not mine but i did share it
      options.push({
        icon: 'trash alternate outline',
        onClick: this.onUnsharePost,
        text: 'Eliminar',
      })
    } else {
      /**
       * @todo Agregar acción de reportar
       */
      /*
      options.push({
        icon: 'ban',
        onClick: this.onBlockPost,
        text: 'Inapropiado',
      })
      */
      options.push({
        icon: 'hide',
        onClick: this.onHidePost,
        text: 'Ocultar',
      })
    }

    options.forEach((elem, index) => {
      options[index].value = options[index].icon
      options[index].selected = false
    })

    return (
      <Dropdown
        className="PostOptions"
        floating
        icon={null}
        options={options}
        pointing="top right"
        trigger={<Icon name="angle down" />}
      />
    )
  }
}

PostOptions.propTypes = {
  onBlockPost: PropTypes.func.isRequired,
  onDeletePost: PropTypes.func.isRequired,
  onEditPost: PropTypes.func.isRequired,
  onHidePost: PropTypes.func.isRequired,
  onUnsharePost: PropTypes.func.isRequired,
  post: PropTypes.oneOfType([SharedPostSchema, PostSchema]).isRequired,

  isAdmin: PropTypes.bool,
  viewer: UserSchema,
}

PostOptions.defaultProps = {
  isAdmin: false,
  viewer: null,
}

export default PostOptions
